import React from 'react'
import { Row } from 'react-bootstrap'

import img1 from '../images/Speed.webp'
import img2 from '../images/Safety.webp'
import img3 from '../images/Innovation.webp'
import img4 from '../images/Integrity.webp'
import img5 from '../images/Certainity.webp'

import './wwer-aifirst.css'

const WwerAifirst = () => {
  return (

    <>
    
    <section className='wwerrooted-section' id='ourvalues'>
        <div className='container py-0 py-md-5'>
            <div className='bl-green'>
                    <h2>Our Values</h2>
                <div className='text-box'>
                    <p>Outside of our skills, these core values of our company are critical to both our own and our customer’s success</p>
                   
                </div>
            </div>
        </div>

        <div className='container'>
            <Row className='align-items-center g-5'>   
                <div className='col-md-6 pe-5 order-m-1'>
                    <h3>People</h3>
                    <p>We treat our people exceptionally well by providing both intrinsic and extrinsic benefits to help them remain happy both personally and professionally. We promote a highly empowering, safe and entrepreneurial work environment which helps us attract and retain top industry talent.</p>
                </div>
                <div className='col-md-6 text-center'>
                    <img src={img1} alt='' />
                </div>
            </Row>
            <Row className='g-5'>
                <div className='col-md-6 text-center'>
                    <img src={img2} alt='' />
                </div>   
                <div className='col-md-6 ps-5'>
                    <h3>Clients</h3>
                    <p>We walk through walls for our clients. We seek to provide a customer experience which is unique, caring, memorable and impactful. As a specialized company focused on strategy and innovation, it is paramount that we align tightly to our client’s teams and strategic objectives and be viewed as a trusted partner and an indispensable part of their organization.</p>
                </div>
                
            </Row>
 
            <Row className='g-5'>   
                <div className='col-md-6 pe-5 order-m-1'>
                    <h3>Innovation</h3>
                    <p>We are always innovating and looking to stay on the ultimate bleeding edge of technology and the establishment of new dynamic business models. We seek to leave repeated footprints of new technology platforms to help our clients truly transform their business. To reframe their purpose. To create step-change 10x outcomes. To actively help our startup companies grow successfully. To help our established enterprise clients turn the tables on digital disrupters while creating their own market disruption.</p>
                </div>
                <div className='col-md-6 text-center'>
                    <img src={img3} alt='' />
                </div>
            </Row>

            <Row className='g-5'>
                <div className='col-md-6 text-center'>
                    <img src={img4} alt='' />
                </div>   
                <div className='col-md-6 ps-5'>
                    <h3>Integrity</h3>
                    <p>We operate as a firm with the highest degree of integrity and business ethics with no exceptions.</p>
                </div>
                
            </Row>

            <Row className='g-5'>   
                <div className='col-md-6 pe-5 order-m-1'>
                    <h3>Social responsibility</h3>
                    <p>We believe in and invest heavily in social responsibility and actively support and promote social causes and impact across our business and investments. We promote diversity in our global workforce. A core part of our solution and portfolio focus is targeted at social areas including Financial Wellness, Health and Wellness and Sustainability.</p>
                </div>
                <div className='col-md-6 text-center'>
                    <img src={img5}  alt='' />
                </div>
            </Row>

        </div>
    </section>
    </>
  )
}

export default WwerAifirst
